// extracted by mini-css-extract-plugin
module.exports = {"item":"MemberCard_item__3r-YW","titleBox":"MemberCard_titleBox__28h0u","iconBox":"MemberCard_iconBox__1VSJ1"};